import React, { PureComponent } from 'react';
import { RED } from '../constants/index';

class TimerDisplay extends PureComponent {

  _resendOTP = () => {
    this.props.resendOtpNum();
    this.props.resetTimer();
  }

  _showElement = () => {
    const { min, sec } = this.props;
    if (min === 0 && sec === 0) {
      return (
        <span>
          <h5
            className='forgot-password-txt'
            onClick={this._resendOTP}>
            Resend OTP
          </h5>
        </span>
      );
    }
    else {
      return (
        <span>
          <h5
            className='forgot-password-txt'
            style={{ color: RED }}
          >
            {'0' + min}:{sec < 10 ? '0' + sec : sec}
          </h5>
        </span>
      );
    }
  }

  _resendLink = () => {

    const { min, sec } = this.props;
    //isLoading checks condition if the server call is currently in progress
    if (min === 0 && sec === 0 && !this.props.isLoading) {
      return (
        <p>
          <h5
            className='forgot-password-txt'
            onClick={this._resendOTP}>
            Resend OTP
          </h5>
        </p>
      );
    }
    else {
      return (
        <p 
         style={{ color: 'grey', cursor: 'not-allowed' }}
         className='forgot-password-txt'
         >
         Resend OTP</p>
      );
    }

  }

  render() {
    const { min, sec } = this.props;
    return (
      // <div> {this._showElement()} </div>
      <div className='flex-horizontal' style={{ justifyContent: 'space-around' }}>
        <span>
          <p
          style={{ color: RED, fontSize:'14px' }}>
          {'0' + min}:{sec < 10 ? '0' + sec : sec}
          </p>
        </span>
        <span>
          {this._resendLink()}
        </span>
      </div>
    );

  }
}

export default TimerDisplay;


// WEBPACK FOOTER //
// ./src/components/TimerDisplay.js